import React, { useState, useEffect } from 'react'
import {
  ComcastErrorType,
  triggerSentryError,
} from '../../../../shared/helpers.js'
import dayjs from 'dayjs'
import CancelDonation from './CancelDonation.tsx'
import ManageMyDonation from './ManageMyDonation.tsx'
import ConfirmDonation from './ConfirmDonation.tsx'
import { ManageDonationComponentsEnums } from './types.ts'
import { getTVaultDonationInformation } from '../../actions/tvaultActions.js'
import { checkPassportStatus } from '../../actions/userActions.js'
import { formatAmount } from '../../lib/helpers.ts'
import Spinner from '../../components/Spinner/Spinner.js'
import { Route, Routes, useNavigate } from 'react-router'
import { useAppSelector } from '../../hooks/useStore'

export default function CancelationScreenTS() {
  const [donationInfo, setDonationInfo] = useState({
    amount: '',
    callSignStation: '',
    interval: '',
    isActive: '',
    memberDate: '',
    nextBilling: '',
    shortNameStation: '',
    subscriptionId: '',
  })

  const [loading, setLoading] = useState(true)
  const [passportActivationStatus, setPassportActivationStatus] = useState<
    string | undefined
  >('')

  const { pid } = useAppSelector((state) => state.user)
  const navigate = useNavigate()

  // Workaround to allow new focus components to work with spatial navigation and old components work with focusable HoC
  // TODO: remove this when whole app is migrated to react spatial navigation
  useEffect(() => {
    window.focusedComponent = {}
    window.focusedComponent.handleBySpatialNavigation = true
    return () => {
      window.focusedComponent.handleBySpatialNavigation = false
    }
  }, [])

  useEffect(() => {
    if (donationInfo.callSignStation) {
      checkPassportStatus(donationInfo.callSignStation)
        .then((passportStatus) => {
          setPassportActivationStatus(passportStatus)
          setLoading(false)
        })
        .catch((error) => {
          triggerSentryError('checkPassportStatus', 'ManageMyDonations.tsx', {
            errorMessage: error.message || 'Error checking passport status',
            errorType: ComcastErrorType.network,
          })
        })
    }
  }, [donationInfo])

  useEffect(() => {
    const fetchDonationInformation = async () => {
      try {
        const donationInformationResponse = await getTVaultDonationInformation(
          pid
        )
        const attributes = donationInformationResponse?.data?.attributes
        const stationInformation =
          donationInformationResponse?.included[2]?.attributes

        setDonationInfo({
          amount: formatAmount(attributes.amount),
          callSignStation: stationInformation.call_sign,
          interval: attributes.interval,
          isActive: attributes?.status,
          memberDate: dayjs(attributes.active_period.start_at).format(
            'MMMM DD, YYYY'
          ),
          nextBilling: dayjs(attributes.next_charge_date).format('MM/DD/YY'),
          shortNameStation: stationInformation.short_common_name,
          subscriptionId: donationInformationResponse?.data?.id,
        })
      } catch (error) {
        triggerSentryError(
          'getTVaultDonationInformation',
          'ManageMyDonations.tsx',
          {
            errorMessage: error.message || 'Error getting donation information',
            errorType: ComcastErrorType.network,
          }
        )
      }
    }

    fetchDonationInformation()
  }, [])

  const handleButtonEnter = (componentKey: ManageDonationComponentsEnums) => {
    navigate(`${componentKey}`)
  }

  if (loading) {
    return <Spinner visible={loading} screen={true} />
  }

  return (
    <>
      <Routes>
        <Route
          path="/"
          element={
            <ManageMyDonation
              donationInfo={donationInfo}
              handleButtonEnter={handleButtonEnter}
              passportActivationStatus={passportActivationStatus}
            />
          }
        />
        <Route
          path="/cancel-donation"
          element={
            <CancelDonation
              donationInfo={donationInfo}
              handleButtonEnter={handleButtonEnter}
            />
          }
        />
        <Route
          path="/confirm-cancel-action"
          element={<ConfirmDonation donationInfo={donationInfo} />}
        />
      </Routes>
    </>
  )
}
